<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">
      <v-layout column justify-center>
          <h1>
            <p class="text-center font-weight-bold">
              Cadastrar Vídeo
            </p>
            <!-- {{recepcionista}} -->
          </h1>
          <v-form ref="form" v-model="valid" class="mx-3">
            {{ nome }} {{ link }}
            <v-text-field v-model="nome" :rules="nomeRules" :type="'text'" label="Nome para o Vídeo" @click:append="show1 = !show1" />
            <v-text-field v-model="link" :rules="linkrules" :type="'text'" name="input-10-1" label="Link" counter @click:append="show1 = !show1" />

            <v-checkbox v-model="checkbox" label="Você concorda?" :rules="[(v) => !!v || 'Voce deve concordar para cadastrar!']" required />
            <v-alert :value="erroEditar" color="error" icon="warning" outlined>
              Erro ao cadastrar o nome!
            </v-alert>

            <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
              Sucesso ao cadastrar o nome!
            </v-alert>

          </v-form>
          <v-card-actions>
            <v-spacer/>
             <v-btn rounded dark :class="{ red: !valid, green: valid }" @click="cadastrarVideo">
              cadastrar
            </v-btn>
            <v-btn text to="/listaVideos">
              <v-icon left>
                keyboard_backspace
              </v-icon>
              voltar
            </v-btn>
          </v-card-actions>
      </v-layout>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

// import EventBus from '../../../main';

export default {
  name: 'EditarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      sucessoEditar: false,
      isEditing: true,
      nome: '',
      link: '',
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 0 || 'Insira um nome'
      ],
      linkrules: [
        (v) => v && v.length > 0 || 'o vídeos deve possuir um link de incorporar'
      ]
    }
  },
  mounted () {
    this.erroEditar = false,
    this.sucessoEditar = false
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 10) {
      this.$router.push('/login')
    }
  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  },
  methods: {

    cadastrarVideo () {
      console.log('em elter vid admDev')
      if (this.$refs.form.validate()) {
        this.erroEditar = false
        this.sucessoEditar = false
        administradorDesenvolvimentoService.administradorDesenvolvimento
          .cadastrarVideo(this.nome, this.link)
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data == true) {
              this.sucessoEditar = true
              this.clear()
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    clear () {
      this.$refs.form.reset()
    }

  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
